import { useQuery } from '@hooks/reactQuery';

import { getMavenirConfigDates } from '@api/dataSources';

import { parseStringDate } from '@utils/date';

import { TMavenirDatesFilter } from '@interfaces/cmModule/dataSources';

import { refetchOptions } from '@constants/common';
import { MAVENIR_CONFIG_DATES } from '@constants/queryKeys';

interface IMavenirConfigDatesOptionsReturnType {
	datesOptions: Date[];
	isLoadingMavenirDatesOptions: boolean;
	latestDateText?: Date;
}

const useQueryMavenirConfigDatesOptions = (): IMavenirConfigDatesOptionsReturnType => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<TMavenirDatesFilter, TMavenirDatesFilter<Date>>({
		queryKey: [MAVENIR_CONFIG_DATES],
		queryFn: getMavenirConfigDates,
		select: (data: TMavenirDatesFilter) => {
			const { datesText, latestDateText } = data;

			const dates = datesText.map((date) => parseStringDate(date));

			return { datesText: dates, latestDateText: parseStringDate(latestDateText) };
		},
		...refetchOptions,
	});

	const { datesText, latestDateText } = data || {};

	return {
		datesOptions: datesText || [],
		latestDateText,
		isLoadingMavenirDatesOptions: isLoading || isFetching,
	};
};

export default useQueryMavenirConfigDatesOptions;
